import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { GetCourseLayoutIconFromCode } from "@whoosh/design-system/src/components/icons_v2/courseLayout";
import { GetTransportIconFromCode } from "@whoosh/design-system/src/components/icons_v2/transportation";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

import {
  SelectedCircle,
  UnselectedCircle,
} from "../SelectionCircles/SelectionCircles";
import { SelectableGolfRound_Round$key } from "./__generated__/SelectableGolfRound_Round.graphql";

export const SelectableGolfRound = ({
  roundRef,
  isSelected,
}: {
  roundRef: SelectableGolfRound_Round$key | null;
  isSelected: boolean;
}) => {
  const roundData = useFragment(SelectableGolfRoundFragmentString, roundRef);
  /**
   * Get relevant Transportation to display
   */
  const transportationTypeCode = roundData?.transportationType?.code;
  const transportationTypeCustomCode =
    roundData?.transportationType?.customCode;
  const TransportationIcon =
    transportationTypeCode && GetTransportIconFromCode(transportationTypeCode);
  /**
   * Get relevant Course Layout to display
   */
  const courseLayoutHoleCount = roundData?.courseLayout?.holeCount;
  const CourseLayoutIcon = GetCourseLayoutIconFromCode(
    courseLayoutHoleCount ?? ""
  );
  return (
    <HStack alignItems="center">
      <HStack gap={3} alignItems="center">
        {isSelected ? <SelectedCircle /> : <UnselectedCircle />}
        {CourseLayoutIcon ? (
          <CourseLayoutIcon />
        ) : (
          <Text>{courseLayoutHoleCount}</Text>
        )}
        {TransportationIcon ? (
          <TransportationIcon />
        ) : (
          <Text>{transportationTypeCustomCode}</Text>
        )}
        <Text variant="mainSmallSemiBold">
          {roundData?.roundRate?.rate?.name}
        </Text>
      </HStack>
    </HStack>
  );
};

const SelectableGolfRoundFragmentString = graphql`
  fragment SelectableGolfRound_Round on Round {
    id
    roundRate {
      rate {
        name
      }
    }
    transportationType {
      id
      code
      customCode
      name
    }
    courseLayout {
      holeCount
    }
    player {
      id
    }
  }
`;
